import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  defaultWallMessage: {
    id: null,
    user_id: null,
    organization_id: null,
    subject: '',
    body: '',
    type: '',
    isInactive: false,
    isInvite: false,
    attachments: null,
  },
  wallmessage: null,
  wallmessages: [],
  mergeTags: [
    {
      id: 0,
      name: 'merge tags',
      value: 'label',
      disabled: true,
    },
    {
      id: 1,
      name: 'First Name',
      value: '*|FirstName|*',
      disabled: false,
    },
    {
      id: 2,
      name: 'Last Name',
      value: '*|LastName|*',
      disabled: false,
    },
    {
      id: 3,
      name: 'Calories',
      value: '*|Calories|*',
      disabled: false,
    },
    {
      id: 4,
      name: 'Percent Goal',
      value: '*|PercentGoal|*',
      disabled: false,
    },
  ],
  cursorUrl: null,
  workingText: null,
})
